module.exports = __webpack_public_path__ + "media/images/xpass/markers/inactive-selected/rowhouse-b3deee68f91dc92b83753b2c1c752040.png";